<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :style="rootStyles"
    :class="rootClasses"
    class="inline-block align-middle"
  >
    <use :xlink:href="href" :href="href" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import icons from '../icons/icons.svg'

const props = withDefaults(
  defineProps<{
    icon: string
    color?: string
    size?: string | number
    strokeWidth?: string | number
  }>(),
  {
    size: 'custom',
  },
)

const rootStyles = computed(() => {
  return {
    custom: { strokeWidth: props.strokeWidth },
    36: { strokeWidth: '1.8px' },
    28: { strokeWidth: '1.8px' },
    24: { strokeWidth: '1.8px' },
    22: { strokeWidth: '1.6px' },
    20: { strokeWidth: '1.4px' },
    18: { strokeWidth: '1px' },
  }[props.size]
})

const rootClasses = computed(() => {
  return [
    props.color,
    {
      custom: [],
      36: ['w-[36px] h-[36px]'],
      28: ['w-[28px] h-[28px]'],
      24: ['w-[24px] h-[24px]'],
      22: ['w-[22px] h-[22px]'],
      20: ['w-[20px] h-[20px]'],
      18: ['w-[18px] h-[18px]'],
    }[props.size],
  ]
})

const href = computed(() => `${icons}#${props.icon}`)
</script>
